import { Link } from "react-router-dom";
import { GitPullRequest } from "lucide-react";
import { usePullRequestByEpicRequest, usePullRequestByJob } from "@/hooks/queries/use-pull-requests";

/**
 * "Review and merge" entry point to the in-app pull request page (ENG-298).
 * Renders nothing until the pull request is known — a 404 just means none yet.
 */
export function PullRequestReviewLink({
  jobId,
  epicRequestId,
  className,
}: {
  jobId?: string;
  epicRequestId?: string;
  className?: string;
}) {
  const byJob = usePullRequestByJob(jobId, !!jobId);
  const byEpicRequest = usePullRequestByEpicRequest(epicRequestId, !jobId && !!epicRequestId);
  const pr = jobId ? byJob.data : byEpicRequest.data;
  if (!pr) return null;
  return (
    <Link
      to={`/pull-requests/${pr.id}`}
      className={
        className ??
        "inline-flex items-center gap-1.5 font-medium text-primary underline underline-offset-2"
      }
    >
      <GitPullRequest className="h-4 w-4" />
      Review and merge #{pr.number}
    </Link>
  );
}
